import React from 'react';
import '../template-file-css/document-file-template.css';


export const MMBHC_RecipientDataPacket = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='MMBHC_RecipientDataPacket' className='file-pdf-document'>
            <div className='file-template'>


                <p className='w-750'> <center> <h3> Client Assignment /Transfer Form </h3> </center>
                </p>

                <table>
                    <tr>
                        <td className='w-350'> <span className='eleHeader'> Name: </span> </td>
                        <td className='w-200'> <span className='eleHeader'> MMBHC #: 015- </span> </td>
                        <td className='w-200'> <span className='eleHeader'> Date: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-350'> <input type='text' id='txtAssignmentName' name='txtAssignmentName' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtMmbhc' name='txtMmbhc' className='add-only' /> </td>
                        <td className='w-200'> <input type='date' id='txtAssignmentDate' name='txtAssignmentDate' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbInitialAssignment' name='cbInitialAssignment' className='add-only' value='Initial Assignment' /> Initial Assignment <br />
                            <input type='checkbox' id='cbTransfer_1' name='cbTransfer_1' className='add-only' value='Transfer' /> Transfer <br />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <b> Effective Date of Assignment/Transfer: </b> </td>
                        <td className='w-450'> <input type='date' id='txtEffectiveDate' name='txtEffectiveDate' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'> Reasons for Transfer/Change (Check all that apply): </span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbChangeInDiagnosis' name='cbChangeInDiagnosis' className='add-only' value='Change in Diagnosis' /> Change in Diagnosis
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbChangeInSymptoms' name='cbChangeInSymptoms' className='add-only' value='Change in Symptoms' /> Change in Symptoms
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbChangeInService' name='cbChangeInService' className='add-only' value='Change in Service Activities' /> Change in Service Activities
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbChangeInTreatment' name='cbChangeInTreatment' className='add-only' value='Change in Treatment' /> Change in Treatment Recommendations
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAppropriateForLess' name='cbAppropriateForLess' className='add-only' value='Appropriate for Less Intensive Service' /> Appropriate for Less Intensive Service
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbTransferOther_1' name='cbTransferOther_1' className='add-only' value='Other' /> Other
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='cbTransferOther_2' name='cbTransferOther_2' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'> List Service(s) Discontinued </span>
                    <textarea id='txtDiscontinued' name='txtDiscontinued' className='add-only'> </textarea>
                </p>
                <p className='w-750'> <span className='eleHeader'> List Service(s) Initiated </span>
                    <textarea id='txtInitiated' name='txtInitiated' className='add-only'> </textarea>
                </p>
                <p className='w-750'> <span className='eleHeader'> Service Change Instructions or Information: </span>
                    <textarea id='txtChangeInstructions' name='txtChangeInstructions' className='add-only'> </textarea>
                </p>
                <p className='w-750'> <span className='eleHeader'> Assigned to: </span>
                    <textarea id='txtAssignedTo' name='txtAssignedTo' className='add-only'> </textarea>
                </p>

                <table>
                    <tr>
                        <td className='signature w-375'> &nbsp; </td>
                        <td className='signature w-375'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> M & M REPRESENTATIVE/CREDENTIALS </td>
                        <td className='small w-375'> DATE </td>
                    </tr>
                </table>

                <p className='w-750'> <center> <h3> CLIENT DATA </h3> </center>
                </p>
                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Admission/Re-admission Date: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Email address: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='date' id='txtAdmission' name='txtAdmission' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtClientEmailAddress' name='txtClientEmailAddress' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-350'> <span className='eleHeader'> Name: </span> </td>
                        <td className='w-200'> <span className='eleHeader'> Date of Birth: </span> </td>
                        <td className='w-200'> <span className='eleHeader'> Age: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-350'> <input type='text' id='txtName_1' name='txtName_1' className='add-only' /> </td>
                        <td className='w-200'> <input type='date' id='txtDateOfBirth_1' name='txtDateOfBirth_1' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtAge' name='txtAge' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> SSN# </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Medicaid# </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtSsn' name='txtSsn' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtMedicaid' name='txtMedicaid' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-350'> <span className='eleHeader'> Height </span> </td>
                        <td className='w-200'> <span className='eleHeader'> Weight </span> </td>
                        <td className='w-200'> <span className='eleHeader'> Eye Color </span> </td>
                    </tr>
                    <tr>
                        <td className='w-350'> <input type='text' id='txtHeight' name='txtHeight' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtWeight' name='txtWeight' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtEyeColor' name='txtEyeColor' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'> Race: </span>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbWhite' name='cbWhite' className='add-only' value='White' /> White
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbBlackOrAfrican' name='cbBlackOrAfrican' className='add-only' value='Black or African American' /> Black or African American
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbHispanic' name='cbHispanic' className='add-only' value='Hispanic' /> Hispanic
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbRaceOther_1' name='cbRaceOther_1' className='add-only' value='Other' /> Other
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Legally Responsible Person </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Relationship </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtLegallyResponsible' name='txtLegallyResponsible' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtRaceRelationship' name='txtRaceRelationship' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-350'> <span className='eleHeader'> Address </span> </td>
                        <td className='w-150'> <span className='eleHeader'> City </span> </td>
                        <td className='w-125'> <span className='eleHeader'> State </span> </td>
                        <td className='w-125'> <span className='eleHeader'> Zip </span> </td>
                    </tr>
                    <tr>
                        <td className='w-350'> <input type='text' id='txtAddress_1' name='txtAddress_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCity_1' name='txtCity_1' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtState_1' name='txtState_1' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtZip_1' name='txtZip_1' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'> How Long at current address? </span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Years </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Months </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtYears' name='txtYears' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtMonths' name='txtMonths' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Home Phone# </span> </td>
                        <td className='w-250'> <span className='eleHeader'> CellPhone # </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Work Phone # </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtHomePhone' name='txtHomePhone' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtcurrentCellPhone' name='txtcurrentCellPhone' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtWorkPhone' name='txtWorkPhone' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'> STUDENT STATUS: </span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbFullTimeStudent' name='cbFullTimeStudent' className='add-only' value='Full-time Student' /> Full-time Student
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPartTimeStudent' name='cbPartTimeStudent' className='add-only' value='Part-time Student' /> Part-time Student
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNotStudent' name='cbNotStudent' className='add-only' value='Not a Student' /> Not a Student
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> School </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Last Grade Completed </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtSchool' name='txtSchool' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtLastGrade' name='txtLastGrade' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'> EMPLOYMENT STATUS: </span>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbEmploymentPartTime' name='cbEmploymentPartTime' className='add-only' value='Part-time' /> Part-time
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbEmploymentFullTime' name='cbEmploymentFullTime' className='add-only' value='Full-time' /> Full-time
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbRetired' name='cbRetired' className='add-only' value='Retired' /> Retired
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbUnemployed' name='cbUnemployed' className='add-only' value='Unemployed' /> Unemployed
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbNotInLaborForce' name='cbNotInLaborForce' className='add-only' value='Not in  labor force' /> Not in  labor force
                        </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'> EMPLOYER: </span>
                    <p className='w-750'> <input type='text' id='txtEmployer' name='txtEmployer' className='add-only' /> </p>
                </p>

                <p className='w-750'> <span className='eleHeader'> Marital Status: </span>
                </p>
                <p className='w-750'>
                    <input type='radio' id='rbMaritalStatus_Single' name='rbMaritalStatus' className='add-only' value='Single' /> Single &nbsp;
                    <input type='radio' id='rbMaritalStatus_Married' name='rbMaritalStatus' className='add-only' value='Female' /> Married
                </p>

                <p className='w-750'> <span className='eleHeader'> Gender: </span>
                </p>
                <p className='w-750'>
                    <input type='radio' id='rbGender_Male' name='rbGender' className='add-only' value='Male' /> Male &nbsp;
                    <input type='radio' id='rbGender_Female' name='rbGender' className='add-only' value='Female' /> Female
                </p>

                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Primary Physician: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Phone #: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Last Seen </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtPrimaryPhysician' name='txtPrimaryPhysician' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPhone_1' name='txtPhone_1' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtLastSeen' name='txtLastSeen' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-350'> <span className='eleHeader'> Address </span> </td>
                        <td className='w-150'> <span className='eleHeader'> City </span> </td>
                        <td className='w-125'> <span className='eleHeader'> State </span> </td>
                        <td className='w-125'> <span className='eleHeader'> Zip </span> </td>
                    </tr>
                    <tr>
                        <td className='w-350'> <input type='text' id='txtAddress_2' name='txtAddress_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCity_2' name='txtCity_2' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtState_2' name='txtState_2' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtZip_2' name='txtZip_2' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <b> EMERGENCY CONTACT INFORMATON </b>
                </p>
                <table>
                    <tr>
                        <td className='w-300'> <span className='eleHeader'> Name </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Relationship to client </span> </td>
                        <td className='w-200'> <span className='eleHeader'> Phone # </span> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <input type='text' id='txtEmergencyName' name='txtEmergencyName' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtRelationshipToClient_1' name='txtRelationshipToClient_1' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPhone_2' name='txtPhone_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <input type='text' id='txtContactName' name='txtContactName' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtRelationshipToClient_2' name='txtRelationshipToClient_2' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtPhone_3' name='txtPhone_3' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='signature w-375'> &nbsp; </td>
                        <td className='signature w-375'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> RECIPIENT/LEGALLY RESPONSIBLE PERSON/DATE </td>
                        <td className='small w-375'> M & M REPRESENTATIVE/CREDENTIALS/DATE </td>
                    </tr>
                </table>

                <p className='w-750'> <center> <h3> TREATMENT PROGRAM RULES </h3> </center>
                </p>
                <p className='w-750'>
                    The services that the Recipient will be provided include screening and assessment, diagnostic determination, individual counseling, psychiatric consultations, medication management, crisis intervention, skill building, and referral to community resources.
                </p>

                <p className='w-750'>
                    The Recipient and/or parent/guardian will meet with the Clinical Manager for an assessment if he or she has not previously received mental health services for one calendar year.  Once the assessment is complete and authorization to receive services through this agency has been confirmed, a mental health specialist and/or mental health professional will be assigned as the Treatment Team. The Treatment Team will work with the Recipient to achieve the goals outlined in the Recipient's Discharge Plan and Treatment Plan. The Team will schedule time during the week, either during/after school or on weekends and evenings. The Recipient and his/her parent guardian will need to be available at the time agreed for these sessions.
                </p>

                <p className='w-750'>
                    Medication management and psychiatric consultations will be scheduled approximately every 30 days at the direction of the Psychiatrist. The Office Manager/Receptionist will call to schedule the appointment at least two weeks in advance and send a reminder notice in the mail of the date and time of the appointment. If a Recipient's a minor, his/her parent/ guardian is required to appear at the appointment with the Recipient.
                </p>

                <p className='w-750'>
                    If a Recipient fails to make an appointment on the scheduled date and time without prior notification, the Recipient or parent/guardian will be mailed a letter asking him/her to contact the office to reschedule the appointment as soon as possible. If a Recipient or parent/guardian is having problems with side effects from medications or has other questions or concerns and feels that another appointment is needed with the Psychiatrist, please call the office. The Psychiatrist will be consulted, and another appointment will be scheduled as needed.
                </p>

                <p className='w-750'>
                    M & M Behavioral Health Center, LLC does not use seclusion or restraint to manage Recipients' behavior. Staff are trained in de-escalation techniques designed to avoid any need for physical restraint.
                </p>

                <p className='w-750'> <b> ACKNOWLEDGEMENT: </b>
                </p>
                <p className='w-750'>
                    I acknowledge that the above Treatment Program Rules have been reviewed and a copy has been provided to me.  I also acknowledge that I am applying voluntarily for mental health services and understand that if approved, the agency is required to provide mental health services as mandated by the Office of Behavioral Health/ Louisiana Behavioral Health Partnership which include:
                </p>

                <p className='w-750'>
                    <ol>
                        <li>
                            Regular, in office, doctor and medication management visits,
                        </li>
                        <li>
                            Psychosocial Rehabilitation services (home, school, and community)
                        </li>
                        <li>
                            Community Psychiatric Support and Treatment (individual)
                        </li>
                        <li>
                            Psychotherapy
                        </li>
                    </ol>
                </p>

                <p className='w-750'>
                    I also understand that if approved, I am required to participate/comply with the Agency and allow personnel to deliver these required services and that refusal to participate in any of the above services will be cause for termination of all services.
                </p>

                <p className='w-750'> <center> <h3> CLIENT FUNDING SOURCE FORM </h3> </center>
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Date: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Client's Chart No. </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='date' id='txtFundingDate' name='txtFundingDate' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtClientChartNo' name='txtClientChartNo' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    All client's services are paid through Louisiana Medicaid. If Louisiana Medicaid does not pay for services rendered, the client is responsible for said services. These services will be based on Louisiana's sliding fee scale. The Client, &nbsp;
                    <input type='text' id='txtLouisianaMedicaid' name='txtLouisianaMedicaid' className='add-only w-200 custom-add-only' /> &nbsp;
                    form of payment will be Louisiana Medicaid &nbsp;
                    <input type='text' id='txtPayment' name='txtPayment' className='add-only w-200 custom-add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'> Name of Bayou Health Plan </span>
                    <p className='w-750'> <input type='text' id='txtBayouHealthPlan' name='txtBayouHealthPlan' className='add-only' /> </p>
                </p>

                <p className='w-750'> <center> <h4> I UNDERSTAND AND HAVE RECEIVED A COPY OF THE FOLLOWING: <br /> NOTIFICATION OF DIAGNOSIS </h4> </center>
                </p>

                <p className='w-750'>
                    I, &nbsp;
                    <input type='text' id='txtGuardianOfTheRecipient' name='txtGuardianOfTheRecipient' className='add-only w-200 custom-add-only' /> &nbsp;
                    parent/guardian of the Recipient, &nbsp;
                    <input type='text' id='txtEducatedOnTheDiagnosis' name='txtEducatedOnTheDiagnosis' className='add-only w-200 custom-add-only' /> &nbsp;
                    have been educated on the diagnosis of &nbsp;
                    <input type='text' id='txtDefiningTheDiagnosis' name='txtDefiningTheDiagnosis' className='add-only w-200 custom-add-only' /> &nbsp;
                    which includes defining the diagnosis, evaluation, and treatment. The Psychiatrist, Licensed Professional Counselor, Mental Health Professional and/or Mental Health Specialist agrees to provide psychoeducation at least monthly and ongoing throughout the Recipient's treatment process.
                </p>

                <p className='w-750'> <center> <h4> I ACKNOWLEDGE I HAVE RECEIVED A COPY OF THE FOLLOWING: <br /> NOTIFICATION OF RECIPIENT RIGHTS </h4> </center>
                </p>
                <p className='w-750'>
                    I understand its contents regarding Recipient rights and responsibilities. I have received a copy of the confidentiality notice, Recipient Handbook (which includes a summary of my rights), and Program Rules. I have also been explained the services, including the benefits and risks, program rules and grievance procedure. I also understand that I may withdraw from M & M Behavioral Health Center anytime I feel treatment/services are not beneficial to me. Staff has answered my questions regarding Recipient rights.
                </p>

                <p className='w-750'>
                    I also understand that specific programs may have additional policies and procedures pertaining to Recipient rights and that those will be explained to me upon entry into the program.
                </p>

                <p className='w-750'> <b> The client is informed at admission of: </b>
                </p>

                <p className='w-750'>
                    <ol>
                        <li>
                            To be informed of the client's rights and responsibilities at the time of admission or within 24 hours of admission
                        </li>
                        <li>
                            To have a family member, chosen representative and/or his or her own physician notified of the admission to the provide at the request of the client
                        </li>
                        <li>
                            To receive treatment and medical services without discrimination based on race, age, religion, national origin, gender, sexual orientation, or disability
                        </li>
                        <li>
                            To maintain the personal dignity of each client
                        </li>
                        <li>
                            To be free from abuse, neglect, exploitation and harassment
                        </li>
                        <li>
                            To receive care in a safe setting
                        </li>
                        <li>
                            To receive the services of a translator or interpreter, if applicable, to facilitate communication between the client and the staff
                        </li>
                        <li>
                            To be informed of the client's own health status and to participate in the development implementation and updating of the client's treatment plan
                        </li>
                        <li>
                            To make informed decisions regarding the client's care by the client or the client's parent or guardian if applicable in accordance with federal and state laws and regulations.
                        </li>
                        <li>
                            To participate or refuse to participate in experimental research when the client gives informed, written consent to such participation or when the client's parent or legal guardian provides such consent when applicable in accordance with federal and state laws and regulations.
                        </li>
                        <li>
                            <b> For clients in residential facilities,</b>to consult freely and privately with the client's legal counsel or to contact an attorney at any reasonable time
                        </li>
                        <li>
                            To be informed in writing, of the policies and procedures for filing a grievance and their review and resolution
                        </li>
                        <li>
                            To submit complaints or grievances without fear of reprisal
                        </li>
                        <li>
                            <b> For clients in residential facilities,</b>to possess and use personal money and belongings, including personal clothing, subject to rules and restrictions imposed by the BHS provider
                        </li>
                        <li>
                            <b> For clients in residential facilities,</b>For clients in residential facilities, to visit or be visited by family and friends subject to rules imposed by the provider and to any specific restrictions documented in the client's treatment plan
                        </li>
                        <li>
                            To have the client's information and medical records, including all computerized medical information, kept confidential in accordance with federal and state statutes and rules/regulations
                        </li>
                        <li>
                            <b> For clients in residential facilities,</b>access to indoor and outdoor recreational and leisure opportunities
                        </li>
                        <li>
                            <b> For clients in residential facilities,</b>to attend or refuse to attend religious services in accordance with his/her faith
                        </li>
                        <li>
                            To be given a copy of the program's rules and regulations upon admission
                        </li>
                        <li>
                            To receive treatment in the least restrictive environment that meets the client's needs
                        </li>
                        <li>
                            To not be restrained or secluded in violation of federal and state laws, rules and regulations
                        </li>
                        <li>
                            To be informed in advance of all estimated charges and any limitations on the length services at the time of admission or within 72 hours
                        </li>
                        <li>
                            To receive an explanation of treatment or rights while in treatment
                        </li>
                        <li>
                            To be informed of: the nature and purpose of any services rendered; the title of personnel providing that service; and the risks, benefits, and side effects of all proposed treatment and medications; the probable health and mental health consequences of refusing treatment; and other available treatments which may be appropriate
                        </li>
                        <li>
                            To accept or refuse all or part of treatment, unless prohibited by court order or a physician deems the client to be a danger to self or others or gravely disabled
                        </li>
                        <li>
                            <b> For children and adolescents in residential BH facilities,</b>to access educational services consistent with the client's age and level of functioning
                        </li>
                        <li>
                            To have a copy of these rights, which includes the information to contact HSS during routine business hours; Health Standards Section, P. O. Box 3767, Baton Rouge, LA 70821 Phone: 225-342-9500 Fax: 225-342-5568
                        </li>
                    </ol>
                </p>

                <p className='w-750'>
                    M & M will implement the use of least restrictive intervention and most appropriate setting and methods as a last resort. M & M Behavioral Health Center prohibits the contingent use of painful body contact, or substances administered to induce bodily painful reactions exclusive.
                </p>

                <p className='w-750'> <center> <h4> RIGHT OF DETERMNINATION APPEAL PROCESS </h4> </center>
                </p>

                <p className='w-750'>
                    M & M will not deny, interrupt, suspend, reduce or terminate your services without a good cause. If you are a Medicaid recipient (or eligible to be one) and a decision has been made to deny, reduce, suspend or terminate services being received, then you have a right to appeal the decision.
                    A notification of the decision will be sent. If you need clarification on any issues, please contact M & M immediately. We will assist you with the appeal process follow-up. Recipients maybe expelled or suspended from services when the agency can no longer meet the recipient's needs or guarantee their safety. M & M shall notify recipients once a specific time is determined to restore services.  M & M shall make efforts to recommend appropriate services that will meet recipient's needs and discharge plan if any.
                </p>

                <p className='w-750'> <center> <h4> PRIVACY NOTICE ACKNOWLEDGEMENT FORM (HIPPA) </h4> </center>
                </p>

                <p className='w-750'>
                    I acknowledge that I have been provided a copy of the Notice of Privacy Practices for M & M Behavioral Health Center. I understand that the Notice of Privacy Practices discusses how my health care information may be used and/ or disclosed, my rights with respect to health care information, and how and where I may file a privacy-related complaint.
                </p>

                <p className='w-750'>
                    I may review a copy of the Notice from M& M Behavioral Health Center Office.
                </p>

                <p className='w-750'>
                    I may obtain a copy of this form from M & M Behavioral Health Center.
                </p>

                <p className='w-750'>
                    I understand that the terms of this Notice may be changed in the future, and these changes will be posted in M & M Behavioral Health Center Office.
                </p>

                <p className='w-750'>
                    I may request a copy of the new Notice by contacting the Privacy Officer.
                </p>

                <p className='w-750'> <center> <h4> ADVANCE DIRECTIVE FOR MENTAL HEALTH TREATMENT </h4> </center>
                </p>

                <p className='w-750'>
                    A psychiatric advance directive is a written document that describes what a person wants to happen; if at some time in the future they are judged to be suffering from a mental disorder in such a way that they are deemed unable to decide for themselves or to communicate effectively.
                </p>

                <p className='w-750'> <span className='eleHeader'> Do you have a psychiatric advance directive? </span>
                </p>
                <p className='w-750'>
                    <input type='radio' id='rbPsychiatric_Yes' name='rbPsychiatric' className='add-only' value='YES' /> YES &nbsp;
                    <input type='radio' id='rbPsychiatric_No' name='rbPsychiatric' className='add-only' value='NO' /> NO
                </p>

                <p className='w-750'> <span className='eleHeader'> Would you like help with completing a psychiatric advance directive? </span>
                </p>
                <p className='w-750'>
                    <input type='radio' id='rbHelpWithCompleting_Yes' name='rbHelpWithCompleting' className='add-only' value='YES' /> YES &nbsp;
                    <input type='radio' id='rbHelpWithCompleting_No' name='rbHelpWithCompleting' className='add-only' value='NO' /> NO
                </p>

                <p className='w-750'> <center> <h4> EMERGENT CARE CONSENT </h4> </center>
                </p>

                <p className='w-750'>
                    As a consumer, parent, or legal guardian of a Recipient I, &nbsp;
                    <input type='text' id='txtAsAconsumer' name='txtAsAconsumer' className='add-only w-200 custom-add-only' /> &nbsp;
                    hereby authorize M & M Behavioral Health Center to obtain emergency medical care for me/my child/the Recipient if the need arises.
                </p>

                <p className='w-750'>
                    Every attempt will be made to contact the Recipient's parent/guardian/relative before obtaining emergency medical care unless life threatening.
                </p>

                <p className='w-750'> <center> <h4> I ACKNOWLEDGE I HAVE EDUCATED ON & RECEIVED CLIENT/FAMILY ORIENTATION </h4> </center>
                </p>
                <p className='w-750'> <b> The client and family have received the following orientation: </b>
                </p>

                <p className='w-750'>
                    <ol type='a'>
                        <li>
                            Ways in which input can be given and the organization's behavioral expectations of the persons served
                        </li>
                        <li>
                            Transition criteria and procedures;
                        </li>
                        <li>
                            Discharge criteria;
                        </li>
                        <li>
                            Response to identification of potential risks to the persons served;
                        </li>
                        <li>
                            Standards of professional conduct related to services;
                        </li>
                        <li>
                            Requirements for reporting and/or follow-up for the mandated person served, regardless of his/her discharge status;
                        </li>
                        <li>
                            Financial obligations, fees, and financial arrangements for services provided by the organization and the program's health;
                        </li>
                        <li>
                            Safety policies regarding the use of seclusion or restraint, use of tobacco products, illegal or legal substances brought into the program; prescription medications brought into the program, and weapons brought into the program;
                        </li>
                        <li>
                            Program rules and expectations of the person served which identify any restrictions the program may place on the persons served;
                        </li>
                        <li>
                            Events, behaviors, or attitudes and their likely consequences;
                        </li>
                        <li>
                            Means by which the person may regain rights or privileges that have been restricted;
                        </li>
                        <li>
                            Familiarization with the premises, including emergency exits and/or shelters, fire suppression equipment, and first aid kits;
                        </li>
                        <li>
                            Education regarding advance directives, when indicated;
                        </li>
                        <li>
                            Identification of the purpose and process of the assessment;
                        </li>
                        <li>
                            Description of how the person-centered plan will be developed;
                        </li>
                        <li>
                            People's participation in goal development and achievements;
                        </li>
                        <li>
                            Potential course of treatment/services;
                        </li>
                        <li>
                            How Motivational incentives may be used;
                        </li>
                        <li>
                            Expectations for family involvement; and
                        </li>
                        <li>
                            Identification of the person(s) responsible for service coordination
                        </li>
                        <li>
                            Confidentiality in accordance with federal and state laws and regulations
                        </li>
                        <li>
                            Grievance process
                        </li>
                        <li>
                            Telephone crisis migration for those staff members who provide such services
                        </li>
                        <li>
                            Client's rights and responsibilities
                        </li>
                    </ol>
                </p>

                <p className='w-750'> <center> <h4> REFUSAL OF TREATMENT </h4> </center>
                </p>

                <p className='w-750'>
                    I, &nbsp;
                    <input type='text' id='txtRefusalOfTreatment' name='txtRefusalOfTreatment' className='add-only w-200 custom-add-only' /> &nbsp;
                    (client's name), am exercising my right to refuse treatment from the psychiatrist and/or psychiatric nurse practitioner at M & M Behavioral Health Center, LLC. I will continue to receive medication management through my primary care physician &nbsp;
                    <input type='text' id='txtExercisingMyRight' name='txtExercisingMyRight' className='add-only w-400 custom-add-only' />
                </p>

                <p className='w-750'> I do give M & M Behavioral Health Center, LLC permission to coordinate my behavioral health care with my primary care physician.
                </p>

                <p className='w-750'> <center> <h4> AUTHORIZATION TO RELEASE HEALTHCARE INFORMATION </h4> </center>
                </p>

                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Client Name: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Date of Birth: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Social Security # </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtClientName_1' name='txtClientName_1' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtDateOfBirth_2' name='txtDateOfBirth_2' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtSocialSecurity_1' name='txtSocialSecurity_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <span className='eleHeader'> Address </span> </td>
                        <td className='w-150'> <span className='eleHeader'> City: </span> </td>
                        <td className='w-150'> <span className='eleHeader'> State: </span> </td>
                        <td className='w-150'> <span className='eleHeader'> Zip: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <input type='text' id='txtAddress_3' name='txtAddress_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCity_3' name='txtCity_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtState_3' name='txtState_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtZip_3' name='txtZip_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            I &nbsp;
                            <input type='text' id='txtTreatment' name='txtTreatment' className='add-only w-200 custom-add-only' /> &nbsp;
                            request and authorize
                        </td>
                        <td className='w-375'> <center> <b> M & M Behavioral Health Center, LLC. </b> <br />
                            712 First Street, <br />
                            Delhi, LA 71232 <br />
                            (O)318-878-6696 (F) 318-878-6698
                        </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Name: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Address: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtName_2' name='txtName_2' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtAddress_4' name='txtAddress_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'> City/State/Zip: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Phone: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Fax: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtCityStateZip_1' name='txtCityStateZip_1' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPhone_4' name='txtPhone_4' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtFax_1' name='txtFax_1' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'> This request and authorization applies to: </span>
                    <p className='w-750'> <input type='text' id='txtAuthorizationApplies_1' name='txtAuthorizationApplies_1' className='add-only' /> </p>
                </p>

                <p className='w-750'> <span className='eleHeader'> Healthcare information relating to the following treatment, conditon, or dates: </span>
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbClinicalEvaluation_1' name='cbClinicalEvaluation_1' className='add-only' value='Part-time' /> Clinical Evaluation
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychologicalEvaluation_1' name='cbPsychologicalEvaluation_1' className='add-only' value='Full-time' /> Psychological Evaluation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychiatricEvaluation_1' name='cbPsychiatricEvaluation_1' className='add-only' value='PsychiatricEvaluation' /> Psychiatric Evaluation
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSocialHistory_1' name='cbSocialHistory_1' className='add-only' value='Social History' /> Social History
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMedicalHistory_1' name='cbMedicalHistory_1' className='add-only' value='Medical History' /> Medical History, examination , Reports
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDischargeSummary_1' name='cbDischargeSummary_1' className='add-only' value='Discharge Summary' /> Discharge Summary
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbLaboratoryResults_1' name='cbLaboratoryResults_1' className='add-only' value='Laboratory Results' /> Laboratory Results
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbQuarterlySummary_1' name='cbQuarterlySummary_1' className='add-only' value='Quarterly Summary' /> Quarterly Summary
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbTreatmentPlan_1' name='cbTreatmentPlan_1' className='add-only' value='Treatment Plan' /> Treatment Plan
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDoctorsProgressNotes_1' name='cbDoctorsProgressNotes_1' className='add-only' value='Doctors Progress Notes' /> Doctor's Progress Notes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPharmacyNotes_1' name='cbPharmacyNotes_1' className='add-only' value='Pharmacy Notes' /> Pharmacy Notes
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbOther_1' name='cbOther_1' className='add-only' value='Other' /> Other
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtOther_1' name='txtOther_1' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <b> This consent is subject to written revocation at any time except to the extent that action has already been taken in reliance upon this consent. This authorization shall expire on </b> &nbsp;
                    <input type='text' id='txtWrittenRevocation' name='txtWrittenRevocation' className='add-only w-200 custom-add-only' /> &nbsp;
                    <b> (date of event). I understand that if I do not specify an expiration date/event, this authorization shall expire in one (1) year. </b>
                </p>

                <p className='w-750'> I understand that the treatment/services are not contingent upon my signing or not signing this authorization. I freely and voluntarily give my authorizaton for the release of information from any health record. I also understand and authorize that this information may be sent via facsimile (fax) transmission.
                </p>

                <p className='w-750'>
                    <b> TO PARTIES RECEIVING THIS INFORMATION. This information has been disclosed to you from records whose confidentiality is protected by federal law.  Federal regulations (42 CFR, Part 2) prohibit you from making further disclosures of it wthout specific written consent of the person to whom it pertains. A general authorization for the release of health or other information is not sufficient for this purpose. </b>
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> RECIPIENT/LEGALLY RESPONSIBLE PERSON: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> DATE: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtRecipientPerson_1' name='txtRecipientPerson_1' className='add-only' /> </td>
                        <td className='w-375'> <input type='date' id='txtDate_1' name='txtDate_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> M & M REPRESENTATIVE/CREDENTIALS: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> DATE: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtRepresentativeCredentials' name='txtRepresentativeCredentials' className='add-only' /> </td>
                        <td className='w-375'> <input type='date' id='txtDate_2' name='txtDate_2' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    I revoke my consent for this authorization. &nbsp;
                    <input type='text' id='txtRevokeMyConsent' name='txtRevokeMyConsent' placeholder='RECIPIENT/LEGALLY RESPONSIBLE PERSON/DATE' className='add-only w-450 custom-add-only' />
                </p>

                <p className='w-750'> <center> <h4> AUTHORIZATION TO RELEASE HEALTHCARE INFORMATION </h4> </center>
                </p>

                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Client Name: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Date of Birth: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Social Security # </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtClientName_2' name='txtClientName_2' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtDateOfBirth_3' name='txtDateOfBirth_3' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtSocialSecurity_2' name='txtSocialSecurity_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <span className='eleHeader'> Address </span> </td>
                        <td className='w-150'> <span className='eleHeader'> City: </span> </td>
                        <td className='w-150'> <span className='eleHeader'> State: </span> </td>
                        <td className='w-150'> <span className='eleHeader'> Zip: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <input type='text' id='txtAddress_5' name='txtAddress_5' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCity_4' name='txtCity_4' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtState_4' name='txtState_4' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtZip_4' name='txtZip_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            I &nbsp;
                            <input type='text' id='txtRequestAndAuthorize_1' name='txtRequestAndAuthorize_1' className='add-only w-200 custom-add-only' /> &nbsp;
                            request and authorize
                        </td>
                        <td className='w-375'> <center> <b> M & M Behavioral Health Center, LLC. </b> <br />
                            712 First Street, <br />
                            Delhi, LA 71232 <br />
                            (O)318-878-6696 (F) 318-878-6698
                        </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Name: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Address: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtName_3' name='txtName_3' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtAddress_6' name='txtAddress_6' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'> City/State/Zip: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Phone: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Fax: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtCityStateZip_2' name='txtCityStateZip_2' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPhone_5' name='txtPhone_5' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtFax_2' name='txtFax_2' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'> This request and authorization applies to: </span>
                    <p className='w-750'> <input type='text' id='txtAuthorizationApplies_2' name='txtAuthorizationApplies_2' className='add-only' /> </p>
                </p>

                <p className='w-750'> <span className='eleHeader'> Healthcare information relating to the following treatment, conditon, or dates: </span>
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbClinicalEvaluation_2' name='cbClinicalEvaluation_2' className='add-only' value='Part-time' /> Clinical Evaluation
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychologicalEvaluation_2' name='cbPsychologicalEvaluation_2' className='add-only' value='Full-time' /> Psychological Evaluation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychiatricEvaluation_2' name='cbPsychiatricEvaluation_2' className='add-only' value='PsychiatricEvaluation' /> Psychiatric Evaluation
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSocialHistory_2' name='cbSocialHistory_2' className='add-only' value='Social History' /> Social History
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMedicalHistory_2' name='cbMedicalHistory_2' className='add-only' value='Medical History' /> Medical History, examination , Reports
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDischargeSummary_2' name='cbDischargeSummary_2' className='add-only' value='Discharge Summary' /> Discharge Summary
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbLaboratoryResults_2' name='cbLaboratoryResults_2' className='add-only' value='Laboratory Results' /> Laboratory Results
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbQuarterlySummary_2' name='cbQuarterlySummary_2' className='add-only' value='Quarterly Summary' /> Quarterly Summary
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbTreatmentPlan_2' name='cbTreatmentPlan_2' className='add-only' value='Treatment Plan' /> Treatment Plan
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDoctorsProgressNotes_2' name='cbDoctorsProgressNotes_2' className='add-only' value='Doctors Progress Notes' /> Doctor's Progress Notes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPharmacyNotes_2' name='cbPharmacyNotes_2' className='add-only' value='Pharmacy Notes' /> Pharmacy Notes
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbOther_2' name='cbOther_2' className='add-only' value='Other' /> Other: IEP, referrals, attendance, etc.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtOther_2' name='txtOther_2' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <b> This consent is subject to written revocation at any time except to the extent that action has already been taken in reliance upon this consent. This authorization shall expire on </b> &nbsp;
                    <input type='text' id='txtRevocation_1' name='txtRevocation_1' className='add-only w-200 custom-add-only' /> &nbsp;
                    <b> (date of event). I understand that if I do not specify an expiration date/event, this authorization shall expire in one (1) year. </b>
                </p>

                <p className='w-750'> I understand that the treatment/services are not contingent upon my signing or not signing this authorization.  I freely and voluntarily give my authorizaton for the release of information from any health record. I also understand and authorize that this information may be sent via facsimile (fax) transmission.
                </p>

                <p className='w-750'>
                    <b> TO PARTIES RECEIVING THIS INFORMATION. This information has been disclosed to you from records whose confidentiality is protected by federal law. Federal regulations (42 CFR, Part 2) prohibit you from making further disclosures of it wthout specific written consent of the person to whom it pertains. A general authorization for the release of health or other information is not sufficient for this purpose.  </b>
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> RECIPIENT/LEGALLY RESPONSIBLE PERSON: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> DATE: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtRecipientPerson_2' name='txtRecipientPerson_2' className='add-only' /> </td>
                        <td className='w-375'> <input type='date' id='txtDate_3' name='txtDate_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> M & M REPRESENTATIVE/CREDENTIALS: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> DATE: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtRepresentative_1' name='txtRepresentative_1' className='add-only' /> </td>
                        <td className='w-375'> <input type='date' id='txtDate_4' name='txtDate_4' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    I revoke my consent for this authorization. &nbsp;
                    <input type='text' id='txtAuthorization_1' name='txtAuthorization_1' placeholder='RECIPIENT/LEGALLY RESPONSIBLE PERSON/DATE' className='add-only w-450 custom-add-only' />
                </p>

                <p className='w-750'> <center> <h4> AUTHORIZATION TO RELEASE HEALTHCARE INFORMATION </h4> </center>
                </p>

                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Client Name: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Date of Birth: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Social Security # </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtClientName_3' name='txtClientName_3' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtDateOfBirth_4' name='txtDateOfBirth_4' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtSocialSecurity_3' name='txtSocialSecurity_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <span className='eleHeader'> Address </span> </td>
                        <td className='w-150'> <span className='eleHeader'> City: </span> </td>
                        <td className='w-150'> <span className='eleHeader'> State: </span> </td>
                        <td className='w-150'> <span className='eleHeader'> Zip: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <input type='text' id='txtAddress_7' name='txtAddress_7' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCity_5' name='txtCity_5' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtState_5' name='txtState_5' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtZip_5' name='txtZip_5' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            I &nbsp;
                            <input type='text' id='txtRequestAndAuthorize_2' name='txtRequestAndAuthorize_2' className='add-only w-200 custom-add-only' /> &nbsp;
                            request and authorize
                        </td>
                        <td className='w-375'> <center> <b> M & M Behavioral Health Center, LLC. </b> <br />
                            712 First Street, <br />
                            Delhi, LA 71232 <br />
                            (O)318-878-6696 (F) 318-878-6698
                        </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Name: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Address: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtName_4' name='txtName_4' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtAddress_8' name='txtAddress_8' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'> City/State/Zip: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Phone: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Fax: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtCityStateZip_3' name='txtCityStateZip_3' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPhone_6' name='txtPhone_6' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtFax_3' name='txtFax_3' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'> This request and authorization applies to: </span>
                    <p className='w-750'> <input type='text' id='txtAuthorizationApplies_3' name='txtAuthorizationApplies_3' className='add-only' /> </p>
                </p>

                <p className='w-750'> <span className='eleHeader'> Healthcare information relating to the following treatment, conditon, or dates: </span>
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbClinicalEvaluation_3' name='cbClinicalEvaluation_3' className='add-only' value='Part-time' /> Clinical Evaluation
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychologicalEvaluation_3' name='cbPsychologicalEvaluation_3' className='add-only' value='Full-time' /> Psychological Evaluation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPsychiatricEvaluation_3' name='cbPsychiatricEvaluation_3' className='add-only' value='PsychiatricEvaluation' /> Psychiatric Evaluation
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSocialHistory_3' name='cbSocialHistory_3' className='add-only' value='Social History' /> Social History
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMedicalHistory_3' name='cbMedicalHistory_3' className='add-only' value='Medical History' /> Medical History, examination , Reports
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDischargeSummary_3' name='cbDischargeSummary_3' className='add-only' value='Discharge Summary' /> Discharge Summary
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbLaboratoryResults_3' name='cbLaboratoryResults_3' className='add-only' value='Laboratory Results' /> Laboratory Results
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbQuarterlySummary_3' name='cbQuarterlySummary_3' className='add-only' value='Quarterly Summary' /> Quarterly Summary
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbTreatmentPlan_3' name='cbTreatmentPlan_3' className='add-only' value='Treatment Plan' /> Treatment Plan
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDoctorsProgressNotes_3' name='cbDoctorsProgressNotes_3' className='add-only' value='Doctors Progress Notes' /> Doctor's Progress Notes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPharmacyNotes_3' name='cbPharmacyNotes_3' className='add-only' value='Pharmacy Notes' /> Pharmacy Notes
                        </td>
                        </tr>
                        <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOther_3' name='cbOther_3' className='add-only' value='Other' /> Other: Permission to be in sessions & discuss behaviors with MHS/MHP
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtOther_3' name='txtOther_3' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <b> This consent is subject to written revocation at any time except to the extent that action has already been taken in reliance upon this consent. This authorization shall expire on </b> &nbsp;
                    <input type='text' id='txtRevocation_2' name='txtRevocation_2' className='add-only w-200 custom-add-only' /> &nbsp;
                    <b> (date of event). I understand that if I do not specify an expiration date/event, this authorization shall expire in one (1) year. </b>
                </p>

                <p className='w-750'> I understand that the treatment/services are not contingent upon my signing or not signing this authorization. I freely and voluntarily give my authorizaton for the release of information from any health record. I also understand and authorize that this information may be sent via facsimile (fax) transmission.
                </p>

                <p className='w-750'>
                    <b> TO PARTIES RECEIVING THIS INFORMATION. This information has been disclosed to you from records whose confidentiality is protected by federal law. Federal regulations (42 CFR, Part 2) prohibit you from making further disclosures of it wthout specific written consent of the person to whom it pertains. A general authorization for the release of health or other information is not sufficient for this purpose. </b>
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> RECIPIENT/LEGALLY RESPONSIBLE PERSON: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> DATE: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtRecipientPerson_3' name='txtRecipientPerson_3' className='add-only' /> </td>
                        <td className='w-375'> <input type='date' id='txtDate_5' name='txtDate_5' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> M & M REPRESENTATIVE/CREDENTIALS: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> DATE: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtRepresentative_2' name='txtRepresentative_2' className='add-only' /> </td>
                        <td className='w-375'> <input type='date' id='txtDate_6' name='txtDate_6' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    I revoke my consent for this authorization. &nbsp;
                    <input type='text' id='txtAuthorization_2' name='txtAuthorization_2' placeholder='RECIPIENT/LEGALLY RESPONSIBLE PERSON/DATE' className='add-only w-450 custom-add-only' />
                </p>

                <p className='w-750'> <center> <h4> AUTHORIZATION FOR SCHOOL VISITS </h4> </center>
                </p>

                <p className='w-750'>
                    I &nbsp;
                    <input type='text' id='txtGuardian' name='txtGuardian' className='add-only w-200 custom-add-only' /> , &nbsp;
                    the parent/ guardian of &nbsp;
                    <input type='text' id='txtChildAtSchool' name='txtChildAtSchool' className='add-only w-200 custom-add-only' /> &nbsp;
                    give M& M reprentative(s) permission to visit my child at school. My child attends &nbsp;
                    <input type='text' id='txtSchoolsAddress' name='txtSchoolsAddress' className='add-only w-200 custom-add-only' /> &nbsp;
                    and the schools address and phone number is &nbsp;
                    <input type='text' id='txtSchoolsCounselor' name='txtSchoolsCounselor' className='add-only w-400 custom-add-only' /> &nbsp;
                    The schools counselor name is &nbsp;
                    <input type='text' id='txtMyChild' name='txtMyChild' className='add-only w-200 custom-add-only' /> &nbsp;
                    My child is in the &nbsp;
                    <input type='text' id='txtTeachersName' name='txtTeachersName' className='add-only w-100 custom-add-only' /> &nbsp;
                    grade and his/her teachers name is &nbsp;
                    <input type='text' id='txtGrade' name='txtGrade' className='add-only w-200 custom-add-only' />
                </p>

                <p className='w-750'> <center> <h4> Place a check below if you decline services to be provided at school. </h4> </center>
                </p>
                <p className='w-750'>
                    <input type='text' id='txtRepresentatives' name='txtRepresentatives' className='add-only w-200 custom-add-only' /> &nbsp;
                    I do not give M & M representatives(s) permission to visit my child at school.
                </p>

                <table>
                    <tr>
                        <td className='signature w-375'> &nbsp; </td>
                        <td className='signature w-375'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> RECIPIENT/LEGALLY RESPONSIBLE PERSON/DATE </td>
                        <td className='small w-375'> M & M REPRESENTATIVE/CREDENTIALS/DATE </td>
                    </tr>
                </table>

                <p className='w-750'> <center> <h4> TEXT MESSAGING/EMAIL CONSENT FORM </h4> </center>
                </p>
                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Name: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Address: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtName_5' name='txtName_5' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtAddress_9' name='txtAddress_9' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Cell Phone: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Email Address: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtCellPhone' name='txtCellPhone' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtMessagingEmailAddress' name='txtMessagingEmailAddress' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <ul>
                        <li>
                            Risk of using text messages/emails. M & M Behavioral Health Center, LLC occasionally offer clients the opportunity to communicate via text messages/emails especially in the case of adolescents and young adults. In the case of minor children, it will be necessary for the parent to consent to their child(ren) communicating with us via text messaging/email on cell phones. Transmitting client information by text messaging/email has a number of risks to be considered before making a final decision regarding its use. These include but are not limited to:
                        </li>
                    </ul>
                </p>

                <p className='w-750'>
                    <ol type='a'>
                        <li>
                            Text messages/emails can be circulated, forwarded or stored in electronic files.
                        </li>
                        <li>
                            Text messages/emails can be immediately broadcasted worldwide and received by many intended and unintended recipients.
                        </li>
                        <li>
                            Senders can easily misaddress a text message/email.
                        </li>
                        <li>
                            Text messaging is easier to falsify than handwritten or signed documents.
                        </li>
                        <li>
                            Backup copies may exist even after sender and/or recipient has deleted their copies.
                        </li>
                        <li>
                            Text messages/emails can be intercepted, altered, forwarded or used without detection or  authorization.
                        </li>
                        <li>
                            Text messages/emails can be used as evidence in court.
                        </li>
                        <li>
                            Text messages/emails can be lost in transmission
                        </li>
                    </ol>
                </p>

                <p className='w-750'>
                    <ul>
                        <li>
                            Conditions for the use of text messaging/emails. We will use reasonable means to protect the security and confidentiality of text messaging/email information sent and received; however, because of the risks outlined above, we cannot guarantee the security and confidentiality of text messaging/email communication and will not be liable for improper disclosure that is not caused by our intentional misconduct. Therefore, clients will need to specifically grant permission for the use of text messaging/emails. Consent to the use of text messages/emails includes agreement with the following conditions:
                        </li>
                    </ul>
                </p>

                <p className='w-750'>
                    <ol type='a'>
                        <li>
                            All text messagings/emails to or from a client can be printed out and become a part of the file in the same way that therapy notes become part of the file.
                        </li>
                        <li>
                            There might be other individuals such as administrative staff who have access to these materials.
                        </li>
                        <li>
                            We will distribute text messages/emails only as necessary with these exceptions: to third parties like attorneys, Guardians ad Litem and, in the case of setting up parenting plans, etc. to the other parent. Attorneys and GALs will receive information after a Release of Information is executed in our office or at the other office. In the case of negotiating parenting plans, custody, and visitation plans, all information can/could/will be shared between the parents. Signing of this document acknowledges that.
                        </li>
                        <li>
                            Although our staff will endeavor to read and respond promptly to a text message/email, we cannot guarantee that any particular text message/email will be read and responded to within a particular period of time. In the case of emergencies please call 911 and go to nearest ER.
                        </li>
                        <li>
                            If the client's text messages/email requires or invites a response from us and the client has not received a response within a reasonable time period, it is the client's responsibility to follow up to determine whether the intended recipient received the text message/email and when a response might be expected.
                        </li>
                        <li>
                            The client should not use text messaging/email for communications regarding extra sensitive materials including physical health issues, mental health diagnoses, and/or substance abuse.
                        </li>
                        <li>
                            The client is responsible for delineating their desire in writing of any information the client does not want sent via text messaging/email.
                        </li>
                        <li>
                            The client is responsible for protecting his/her password or other means of access. We are not liable for breaches of confidentiality cause by a client or other third party.
                        </li>
                    </ol>
                </p>

                <p className='w-750'>
                    <ul>
                        <li>
                            Instruction for communicating via text messaging/email.
                        </li>
                    </ul>
                </p>

                <p className='w-750'>
                    <ol type='a'>
                        <li>
                            Inform us in writing of changes in text messaging/email address/phone number
                        </li>
                        <li>
                            Put the clients name and purpose of text message/email in the  subject line
                        </li>
                        <li>
                            Send a reply message or delivery receipt to us to acknowledge clients' receipt of any text messaging/email.
                        </li>
                        <li>
                            Withdraw consent to utilize text messaging/email only by written communication.
                        </li>
                    </ol>
                </p>

                <p className='w-750'>
                    <ul>
                        <li>
                            Client acknowledgement and agreement: I acknowledge that I have read and fully understand this consent form. I understand the risks as outlined above and consent to the conditions outlined above. I further waive any and all claims that may arise against M & M Behavioral Health Center, LLC, employees, contractors, interns, and practicum students resulting from the use or misuse of text messaging/email.
                        </li>
                    </ul>
                </p>

                <p className='w-750'> <center> <h4> Informed Consent Telemedicine/Telehealth </h4> </center>
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Patient Name: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Date of Birth: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtPatientName' name='txtPatientName' className='add-only' /> </td>
                        <td className='w-375'> <input type='date' id='txtDateOfBirth_5' name='txtDateOfBirth_5' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-350'> <span className='eleHeader'> Patient Address: </span> </td>
                        <td className='w-150'> <span className='eleHeader'> City: </span> </td>
                        <td className='w-125'> <span className='eleHeader'> State: </span> </td>
                        <td className='w-125'> <span className='eleHeader'> Zip Code: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-350'> <input type='text' id='txtPatientAddress' name='txtPatientAddress' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtCity_6' name='txtCity_6' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtState_6' name='txtState_6' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='txtZipCode' name='txtZipCode' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'> Date Consent was Discussed: </span>
                </p>
                <p className='w-750'> <input type='text' id='txtDateConsent' name='txtDateConsent' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'> Physician Name: </span>
                </p>
                <p className='w-750'> <input type='text' id='txtPhysicianName' name='txtPhysicianName' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'> Consultant Name: </span>
                </p>
                <p className='w-750'> <input type='text' id='txtConsultantName_1' name='txtConsultantName_1' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'> Consultant Name: </span>
                </p>
                <p className='w-750'> <input type='text' id='txtConsultantName_2' name='txtConsultantName_2' className='add-only' />
                </p>

                <p className='w-750'>
                    I &nbsp;
                    <input type='text' id='txtTelemedicine' name='txtTelemedicine' className='add-only w-200 custom-add-only' /> &nbsp;
                    hereby consent to engage in telemedicine/telehealth with M & M Behavioral Health Center as part of my treatment. I understand that telemedicine/telehealth includes the practice of health care delivery, diagnosis, consultation, treatment and transfer of medical information and education using interactive audio and/or video data communication. I understand that telemedicine/ telehealth also involves communication of any medical or mental health information both orally and verbally to health care practitioners, specialist, subspecialist, or any other agency previously agreed upon.
                </p>

                <p className='w-750'> I understand I have the following rights with respect to telemedicine/telehealth.
                </p>

                <p className='w-750'>
                    <ol>
                        <li>
                            I have the right to withhold or withdraw consent at any time without affecting my right to future treatment with M & M Behavioral Health Center.
                        </li>
                        <li>
                            The laws that protect the confidentiality of my medical information also apply to telemedicine/telehealth.
                        </li>
                        <li>
                            I understand that the information disclosed by me during the course of therapy is generally confidential, however there are both mandatory and permissive expectations to confidentiality including but not limited to reporting child, elder, and dependent adult abuse, expressed threats of violence towards an ascertainable victim and where I make my mental or emotional state an issue in legal proceedings.
                        </li>
                        <li>
                            I understand that there are risk and consequences from telemedicine/telehealth including but not limited to the possibility of the transmission being disrupted or distracted by technical failure.
                        </li>
                        <li>
                            I have the right to inspect all information obtained and recorded in the telemedicine/ telehealth sessions and may receive copies for a reasonable fee.
                        </li>
                        <li>
                            I understand that it is my duty to inform M & M Behavioral Health Center of electronic action concerning my care that I may have with other health care providers.
                        </li>
                        <li>
                            I attest that I am in the state of Louisiana and will remain in the state of Louisiana during my care.
                        </li>
                        <li>
                            I have a right to be informed of all persons who are present and the roll of that person.
                        </li>
                        <li>
                            I have the right to the rational for using telemedicine/telehealth services.
                        </li>
                    </ol>
                </p>

                <p className='w-750'> Services will be in a quite private space that is free from distraction. Please contact us for possible treatment alternatives and those risk and benefits. Please contact our office to discuss the risk or benefit of no treatment.
                </p>

                <p className='w-750'> I have read and understand the information provided above regarding telemedicine/ telehealth, have discussed it with my physician and counselors and all my questions have been answered to my satisfaction. I hereby give my informed consent for the use of telemedicine/telehealth in my mental health care.
                </p>

                <p className='w-750'> I hereby authorize M & M Behavioral Health Center to used telemedicine/telehealth during my diagnosis and treatment.
                </p>

                <table>
                    <tr>
                        <td className='signature w-375'> &nbsp; </td>
                        <td className='signature w-375'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> RECIPIENT/LEGALLY RESPONSIBLE PERSON/ DATE </td>
                        <td className='small w-375'> M &M REPRESENTATIVE/CREDENTIALS/DATE </td>
                    </tr>
                </table>

                <p className='w-750'> I agree and consent that I have reviewed each form listed below with a representative from M & M Behavioral Health Center, LLC. I agree that I have received a copy of Client Family Orientation Packet which includes: (1) Recipient's Rights; (2) Client Abuse and/or Neglect information; (3) Rights to Appeal Determination; and (4) Notice of Privacy Practices. By signing below, I agree and attest to each form.
                </p>

                <p className='w-750'>
                    <ol>
                        <li>
                            Healthy Louisiana Mental Health Rehabilitation Member Choice
                        </li>
                        <li>
                            Informed Consent Telemedicine/Telehealth
                        </li>
                        <li>
                            Client Data Sheet
                        </li>
                        <li>
                            Treatment Program Rules
                        </li>
                        <li>
                            Client Funding Source
                        </li>
                        <li>
                            Notification of Diagnosis
                        </li>
                        <li>
                            Notification of Recipient Rights
                        </li>
                        <li>
                            Advance Directive for Mental Health Treatment
                        </li>
                        <li>
                            Emergent Care Consent
                        </li>
                        <li>
                            Client/Family Orientation
                        </li>
                        <li>
                            Refusal of Treatment (if applicable)
                        </li>
                        <li>
                            Authorization to Release Healthcare Information
                        </li>
                        <li>
                            Authorization for School Visits (if applicable)
                        </li>
                        <li>
                            Text Messaging/Email Consent
                        </li>
                        <li>
                            For Your Safety Orientation Newsletter
                        </li>
                    </ol>
                </p>

                <table>
                    <tr>
                        <td className='signature w-375'> &nbsp; </td>
                        <td className='signature w-375'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> RECIPIENT/DATE </td>
                        <td className='small w-375'> LEGALLY RESPONSIBLE PERSON/DATE </td>
                    </tr>
                    <tr>
                        <td className='signature w-750'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'> M & M REPRESENTATIVE/CREDENTIALS/DATE </td>
                    </tr>
                </table>

            </div>
        </form >

    )
}
